import { render, staticRenderFns } from "./NotificationListing.vue?vue&type=template&id=d5b779a2&scoped=true"
import script from "./NotificationListing.vue?vue&type=script&lang=js"
export * from "./NotificationListing.vue?vue&type=script&lang=js"
import style0 from "./NotificationListing.vue?vue&type=style&index=0&id=d5b779a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b779a2",
  null
  
)

export default component.exports